import React, { useState, useEffect } from 'react';
import { setCookie,setCookieAux } from '../utils/cookiesUtil';

const useCookie = (key) => {
    const [cookieState, setCookieState] = useState("");
    const [cookieStateAux, setCookieStateAux] = useState("");

    const updateCookieState = (val) => {
        setCookieState(val || "");
    }
    const updateCookieStateAux = (val) => {
        setCookieStateAux(val || "");
    }

    useEffect(() => {
        setCookie(key, "");
        setCookieAux(key, "");
    }, []);

    useEffect(() => {
        setCookie(key, cookieState);
    }, [cookieState]);

    useEffect(() => {
        setCookieAux(key, cookieStateAux);
    }, [cookieStateAux]);

    return { updateCookieState,updateCookieStateAux }
}

export default useCookie